import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography, AvatarGroup, } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import color from "../../../../constants/color";
import styles from "./style";
// import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../../components/CustomPagination";
import profile from "../../../../assets/ViewLeave-images/Payroll.svg";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/Modal";
import { formatDate } from "../../../../utils/DateFormat";


const LeaveManagementList = ({ data, handleDelete, page, setPage, count }) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(8);

  const deleteData = (item) => {
    setValue(item);
  }

  const handleViewPayroll = (item) => {
    navigate("/dashboard/payrollModule/addPayroll", { state: { from: "Edit", item } });
  }

  const handleDeleteItem = () => {
    handleDelete(value);
    setOpen(false);
  };


  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Payroll Name</TableCell>
              <TableCell sx={styles.TableHead}>Employee</TableCell>
              <TableCell sx={styles.TableHead}>Date</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableAvtardata}>
                    <Avatar src={profile} sx={styles.profileAvtar} /><Box >
                      <Typography sx={styles.name}>{item?.name}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    <AvatarGroup total={item?.employeeDetails.length} key={index} sx={{ justifyContent: "left", }}>
                      <Avatar src={item?.employeeDetails[0]?.personalInfo?.image} />
                      <Avatar src={item?.employeeDetails[1]?.personalInfo?.image} />
                      <Avatar src={item?.employeeDetails[2]?.personalInfo?.image} />
                    </AvatarGroup>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>{formatDate(String(item?.date ?? item?.end ?? "").slice(0, 10))}</TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", width: { xs: "100%", lg: "80%" } }}>
                      <RemoveRedEyeOutlinedIcon sx={{ color: color.lightText, mx: 2, cursor: "pointer" }} onClick={() => { handleViewPayroll(item) }} />
                      <DeleteOutlineIcon sx={{ color: "#ff0000", ml: 2, cursor: "pointer" }} onClick={() => { deleteData(item?._id), setOpen(true) }} /></Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                  No Data Found
                </TableCell>
              </TableRow>
            )
            }
          </TableBody>
        </Table>
        {data &&
          <CustomPagination
            pageCount={count}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}
      </TableContainer>
      <Modal open={open} setOpen={setOpen} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Employee"} handleDelete={handleDeleteItem}>
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};
export default LeaveManagementList;
